"use strict";
/**
 * This code was GENERATED using the solita package.
 * Please DO NOT EDIT THIS FILE, instead rerun solita to update it or write a wrapper to add functionality.
 *
 * See: https://github.com/metaplex-foundation/solita
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTransferInstruction = exports.transferInstructionDiscriminator = exports.transferStruct = void 0;
const splToken = __importStar(require("@solana/spl-token"));
const beet = __importStar(require("@metaplex-foundation/beet"));
const web3 = __importStar(require("@solana/web3.js"));
/**
 * @category Instructions
 * @category Transfer
 * @category generated
 */
exports.transferStruct = new beet.BeetArgsStruct([['instructionDiscriminator', beet.uniformFixedSizeArray(beet.u8, 8)]], 'TransferInstructionArgs');
exports.transferInstructionDiscriminator = [
    163, 52, 200, 231, 140, 3, 69, 186,
];
/**
 * Creates a _Transfer_ instruction.
 *
 * @param accounts that will be accessed while the instruction is processed
 * @category Instructions
 * @category Transfer
 * @category generated
 */
function createTransferInstruction(accounts, programId = new web3.PublicKey('ocp4vWUzA2z2XMYJ3QhM9vWdyoyoQwAFJhRdVTbvo9E')) {
    const [data] = exports.transferStruct.serialize({
        instructionDiscriminator: exports.transferInstructionDiscriminator,
    });
    const keys = [
        {
            pubkey: accounts.policy,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: accounts.freezeAuthority,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: accounts.mint,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: accounts.metadata,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: accounts.mintState,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: accounts.from,
            isWritable: false,
            isSigner: true,
        },
        {
            pubkey: accounts.fromAccount,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: accounts.to,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: accounts.toAccount,
            isWritable: true,
            isSigner: false,
        },
        {
            pubkey: accounts.tokenProgram ?? splToken.TOKEN_PROGRAM_ID,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: accounts.cmtProgram,
            isWritable: false,
            isSigner: false,
        },
        {
            pubkey: accounts.instructions,
            isWritable: false,
            isSigner: false,
        },
    ];
    const ix = new web3.TransactionInstruction({
        programId,
        keys,
        data,
    });
    return ix;
}
exports.createTransferInstruction = createTransferInstruction;
//# sourceMappingURL=data:application/json;base64,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